import { resolveWorkspaceAccess, WorkspaceAccess } from 'utils/workspace-access'
export { resolveWorkspaceAccess } from 'utils/workspace-access'
export type { WorkspaceAccess } from 'utils/workspace-access'
import { useLocation, useParams } from 'react-router-dom'
import { useAccountStore } from 'store'

export const useWorkspaceAccess = (): {
	access: WorkspaceAccess
	ready: boolean
} => {
	const account = useAccountStore((s) => s.account)
	const params = useParams()
	const { pathname } = useLocation()
	const accountId =
		params.accountId || pathname.match(/\/workspace\/([^/]+)/)?.[1]
	if (accountId === 'workspace-demo') return { access: 'full', ready: true }
	if (!account || (accountId && account.id !== accountId))
		return { access: 'not-started', ready: false }
	return { access: resolveWorkspaceAccess(account), ready: true }
}
